export default __webpack_public_path__ + "4bfb3036e48813c1ca73fb86554fc409.jpg";